import React from "react";
import { Autocomplete, Checkbox, Grid, TextField } from "@mui/material";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";

const iconoBlank = <CheckBoxOutlineBlankIcon fontSize="small" />;
const iconoCheck = <CheckBoxIcon fontSize="small" />;

export const SIN_ASIGNAR = "sin_asignar";

// Criterios por los que se puede filtrar/agrupar (id y nombre de cada fila de precio)
export const CRITERIOS = [
  { campo: "sucursal", label: "Sucursal", id: (p) => p.id_sucursal, nombre: (p) => p.nombre_sucursal },
  { campo: "iva", label: "Situación IVA", id: (p) => p.situacion_iva, nombre: (p) => p.nombre_situacioniva },
  { campo: "tipo", label: "Tipo de cliente", id: (p) => p.id_tipocliente, nombre: (p) => p.tipo_cliente },
  { campo: "categoria", label: "Categoría", id: (p) => p.id_categoria, nombre: (p) => p.categoria },
  { campo: "localidad", label: "Localidad", id: (p) => p.id_localidad, nombre: (p) => p.localidad },
  { campo: "comercial", label: "Comercial", id: (p) => p.id_comercial, nombre: (p) => p.comercial },
  { campo: "condicion", label: "Condición de pago", id: (p) => p.id_condicionpago, nombre: (p) => p.condicion },
  { campo: "producto", label: "Producto", id: (p) => p.producto, nombre: (p) => p.nombre_producto },
];

// Normaliza id/nombre de un criterio para una fila (los NULL quedan como "Sin asignar")
export const valorCriterio = (criterio, p) => {
  const id = criterio.id(p);
  if (id === null || id === undefined || id === "") {
    return { id: SIN_ASIGNAR, nombre: "Sin asignar" };
  }
  return { id, nombre: criterio.nombre(p) ?? "Sin asignar" };
};

// Barra de filtros múltiples (un Autocomplete por criterio con más de una opción)
function FiltrosPrecios({ opciones, filtros, onChangeFiltro }) {
  return (
    <Grid container spacing={2}>
      {CRITERIOS.filter((c) => (opciones[c.campo] ?? []).length > 1).map((c) => (
        <Grid item xs={12} sm={6} md={3} key={c.campo}>
          <Autocomplete
            multiple
            disableCloseOnSelect
            size="small"
            options={opciones[c.campo]}
            getOptionLabel={(o) => o.nombre ?? ""}
            isOptionEqualToValue={(o, v) => o.id === v.id}
            value={filtros[c.campo] ?? []}
            onChange={(_, value) => onChangeFiltro(c.campo, value)}
            limitTags={1}
            renderOption={(props, option, { selected }) => (
              <li {...props} key={option.id}>
                <Checkbox
                  icon={iconoBlank}
                  checkedIcon={iconoCheck}
                  style={{ marginRight: 8 }}
                  checked={selected}
                />
                {option.nombre} ({option.cant})
              </li>
            )}
            renderInput={(params) => (
              <TextField {...params} label={c.label} placeholder="Buscar..." />
            )}
          />
        </Grid>
      ))}
    </Grid>
  );
}

export default FiltrosPrecios;
